import { DONATION_AMOUNT_LIMIT } from '@worldcoo/shared/core';

/**
 * Whether the form can already tell an amount is above the ceiling. The ceiling is in euros and core checks it on
 * the amount converted to them, so only a EUR amount is judged here; the preregistration refuses any other.
 */
export const isAboveCeilingUpFront = (amount: number, currencyCode: string): boolean =>
	currencyCode === 'EUR' && amount > DONATION_AMOUNT_LIMIT;
